/**@jsx h */
import { motion } from 'framer-motion'
import { h } from 'preact'
import { useState, useRef } from 'preact/hooks'
export const Big = (props) =>{
 return(
<span {...props} style={{ fontWeight : `${props.level * 300}`, fontSize : `${props.level * 16}pt` }}>
    {props.children}
</span>)
}

export const Themer = ({}) =>{
 var themes = [
   {
     name : 'dark',
     color : '#292929'
   },
   {
    name : 'blue',
    color : '#0779e4'
  },
  {
    name : 'red',
    color : '#e8505b'
  }
 ]
 const el = useRef()
 const [open, setOpen] = useState(false)
 const [theme, setTheme] = useState(localStorage._THEME_ || 'default')
 document.body.classList.value = ""
 document.body.classList.add(theme)
 function themeSetter(k){
  setTheme(k)
  localStorage._THEME_ = k
 }

 
 return <motion.div 
 ref={el}
 className={`Themer ${open ? 'open' : ''}`} 
 animate={{
   width : open ? (themes.length * 75 ) : 50
 }}
 onClick={v=> {setOpen(!open); }}>
   {/** themes icon */}
    <motion.div 
    className="themeIcon"
    animate={{
      visibility : open ? 'hidden' : 'visible',
      opacity : open ? 0 : 1
    }}>
      <svg version="1.1" class="has-solid " viewBox="0 0 36 36" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink" focusable="false" role="img" width="32" height="32" fill="black"><path d="M21.54,23.05a3.22,3.22,0,0,1-3-1.77A3.05,3.05,0,0,1,18.5,19a3.74,3.74,0,0,1,1.95-2.06A3.4,3.4,0,0,1,25,18.3a3,3,0,0,1,.08,2.32,3.69,3.69,0,0,1-2,2.07A3.85,3.85,0,0,1,21.54,23.05Zm.54-4.91a2.41,2.41,0,0,0-1,.21h0A2.13,2.13,0,0,0,20,19.51a1.37,1.37,0,0,0,0,1.09,1.81,1.81,0,0,0,2.45.63,2.1,2.1,0,0,0,1.12-1.15,1.4,1.4,0,0,0,0-1.1A1.59,1.59,0,0,0,22.08,18.14Zm-1.29-.52h0Z" class="clr-i-outline clr-i-outline-path-1"/><path d="M16.19,33.87A13.72,13.72,0,0,1,6.4,30,13.86,13.86,0,0,1,2,20c0-4.4,2-8.84,5.68-12.5a18.2,18.2,0,0,1,13.1-5.37h.12c3.33,0,6.85,1.49,7.24,4.73.21,1.77-.59,3.47-1.29,5-.55,1.17-1.11,2.39-.72,2.81s1,.12,2.09-.2a6.27,6.27,0,0,1,3.38-.36,3,3,0,0,1,1.87,1.56c.94,1.83.47,4.67-.23,6.54h0A17.38,17.38,0,0,1,29,28.74,19.43,19.43,0,0,1,16.19,33.87ZM20.78,4.16A16.22,16.22,0,0,0,9.09,9C5.79,12.23,4,16.16,4,20A11.92,11.92,0,0,0,7.8,28.6c5.38,5.25,14.62,3.55,19.87-1.33a15.52,15.52,0,0,0,3.7-5.75h0c.7-1.9.84-3.92.32-4.92a1,1,0,0,0-.61-.55,4.86,4.86,0,0,0-2.29.35c-1.31.39-3,.89-4.12-.35-1.32-1.4-.46-3.25.37-5a7.93,7.93,0,0,0,1.11-3.9c-.24-2-2.81-2.95-5.26-3Z" class="clr-i-outline clr-i-outline-path-2"/><path d="M23.87,26.65A2.59,2.59,0,0,0,22.35,25L22,24.9l-.46,1.53.16,0a1,1,0,0,1,.6.61c.17.6-.41,1.31-1.26,1.55s-1.71-.07-1.88-.66l-1.54.43h0a2.83,2.83,0,0,0,2.84,1.91,4,4,0,0,0,1-.14A3,3,0,0,0,23.87,26.65Z" class="clr-i-outline clr-i-outline-path-3"/><path d="M15.07,25.59h0a2.73,2.73,0,0,0-2.24-1.84l-.27,1.58a1.12,1.12,0,0,1,1,.7c.17.59-.41,1.3-1.26,1.54A1.92,1.92,0,0,1,11,27.52a1,1,0,0,1-.6-.61s0-.09,0-.13l-1.58.16a2,2,0,0,0,.06.41A2.59,2.59,0,0,0,10.37,29a3.36,3.36,0,0,0,1.31.25,3.7,3.7,0,0,0,1-.14A3,3,0,0,0,15.07,25.59Z" class="clr-i-outline clr-i-outline-path-4"/><path d="M10.78,19.17a2.59,2.59,0,0,0-1.52-1.65,2.91,2.91,0,0,0-.5-.16l-.37,1.56a1.21,1.21,0,0,1,.25.08,1,1,0,0,1,.6.6c.17.6-.41,1.31-1.26,1.55s-1.71-.06-1.88-.66a.86.86,0,0,1,0-.39l-1.56-.34a2.4,2.4,0,0,0,0,1.16A2.83,2.83,0,0,0,7.4,22.83a4,4,0,0,0,1-.14A3,3,0,0,0,10.78,19.17Z" class="clr-i-outline clr-i-outline-path-5"/><path d="M13.45,11.4a2.59,2.59,0,0,0-1.52-1.65,1.17,1.17,0,0,0-.2-.06l-.52,1.51a.38.38,0,0,1,.1,0,1,1,0,0,1,.6.6c.17.6-.41,1.31-1.26,1.55a2.06,2.06,0,0,1-1.28-.05,1,1,0,0,1-.6-.61.85.85,0,0,1,0-.32l-1.58-.19a2.3,2.3,0,0,0,.06.94A2.56,2.56,0,0,0,8.75,14.8a3.37,3.37,0,0,0,1.31.26,4,4,0,0,0,1-.14A3,3,0,0,0,13.45,11.4Z" class="clr-i-outline clr-i-outline-path-6"/><path d="M21,6.78a2.56,2.56,0,0,0-1.52-1.65l-.3-.1L18.7,6.56l.15,0a1,1,0,0,1,.6.61c.17.6-.41,1.3-1.26,1.54s-1.71-.06-1.88-.65a.9.9,0,0,1,.06-.58L14.89,6.9a2.47,2.47,0,0,0-.12,1.63,2.84,2.84,0,0,0,2.84,1.91,3.58,3.58,0,0,0,1-.15A3,3,0,0,0,21,6.78Z" class="clr-i-outline clr-i-outline-path-7"/><path d="M32.23,14.89c-2.1-.56-4.93,1.8-6.34.3-1.71-1.82,2.27-5.53,1.86-8.92-.33-2.78-3.51-4.08-6.66-4.1A18.5,18.5,0,0,0,7.74,7.59c-6.64,6.59-8.07,16-1.37,22.48,6.21,6,16.61,4.23,22.67-1.4a17.73,17.73,0,0,0,4.22-6.54C34.34,19.23,34.44,15.49,32.23,14.89ZM9.4,10.57a2.23,2.23,0,0,1,2.87,1.21,2.22,2.22,0,0,1-1.81,2.53A2.22,2.22,0,0,1,7.59,13.1,2.23,2.23,0,0,1,9.4,10.57ZM5.07,20.82a2.22,2.22,0,0,1,1.82-2.53A2.22,2.22,0,0,1,9.75,19.5,2.23,2.23,0,0,1,7.94,22,2.24,2.24,0,0,1,5.07,20.82Zm7,8.33a2.22,2.22,0,0,1-2.87-1.21A2.23,2.23,0,0,1,11,25.41a2.23,2.23,0,0,1,2.87,1.21A2.22,2.22,0,0,1,12,29.15ZM15,8.26a2.23,2.23,0,0,1,1.81-2.53,2.24,2.24,0,0,1,2.87,1.21,2.22,2.22,0,0,1-1.82,2.53A2.21,2.21,0,0,1,15,8.26Zm5.82,22.19a2.22,2.22,0,0,1-2.87-1.21,2.23,2.23,0,0,1,1.81-2.53,2.24,2.24,0,0,1,2.87,1.21A2.22,2.22,0,0,1,20.78,30.45Zm5-10.46a3.2,3.2,0,0,1-1.69,1.76,3.53,3.53,0,0,1-1.4.3,2.78,2.78,0,0,1-2.56-1.5,2.49,2.49,0,0,1-.07-2,3.2,3.2,0,0,1,1.69-1.76,3,3,0,0,1,4,1.2A2.54,2.54,0,0,1,25.79,20Z" class="clr-i-solid clr-i-solid-path-1" style="display:none"/></svg>
    </motion.div>  
    {/** themes icon end */}
    <motion.div 
    className="themes"
    animate={{
      visibility : open ? 'visible' : 'hidden',
      opacity : open ? 1 : 0
    }}
    >
      {
      themes.map(t => <span
         style={{background : t.color}}
         onClick={v=>{ themeSetter(t.name) }}
         ></span>)
      }
    </motion.div>
 </motion.div>

}